// open update modal
export const APPLICATION_UPDATE_MODAL_OPEN = 'APPLICATION_UPDATE_MODAL_OPEN'
export const APPLICATION_UPDATE_MODAL_CLOSE = 'APPLICATION_UPDATE_MODAL_CLOSE'

// app update
export const APPLICATION_VERSION_UPDATE_STAGE_SET = 'APPLICATION_VERSION_UPDATE_STAGE_SET'
